import { Component } from 'react'
import PropTypes from 'prop-types'
import { DangerAlert } from 'components/alerts'

export default class Form extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }

  render() {
    const { error, className, onSubmit, children } = this.props

    return (
      <form className={className} onSubmit={onSubmit}>
        {error && <DangerAlert>{error}</DangerAlert>}
        {children}
      </form>
    )
  }
}
